import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import has from 'lodash/has';

const PaginateKey = ({ page, content, show, isActive }) => {
  const { query } = useRouter();
  const hasCategory = has(query, 'category');
  const hasAuthor = has(query, 'author');
  const hasSearchKey = has(query, 's');

  let href = '/blog';
  let as = '/blog';

  if (hasCategory) {
    href = '/blog/topics/[category]';
    as = `/blog/topics/${query.category}`;
  }

  if (hasAuthor) {
    href = '/blog/author/[author]';
    as = `/blog/author/${query.author}`;
  }

  if (page !== 1) {
    href = `${href}/page/[page]`;
    as = `${as}/page/${page}`;
  }

  if (hasSearchKey) {
    const searchQuery = hasSearchKey ? `?s=${query.s.replace(/\s/g, '+')}` : '';
    href = `${href}${searchQuery}`;
    as = `${as}${searchQuery}`;
  }

  return show ? (
    <li className={isActive ? 'active' : ''}>
      <Link href={href} as={as}>
        <a role="button" tabIndex="0">
          {content}
        </a>
      </Link>
    </li>
  ) : null;
};

PaginateKey.propTypes = {
  page: PropTypes.number.isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  show: PropTypes.bool,
  isActive: PropTypes.bool,
};

PaginateKey.defaultProps = {
  content: '',
  show: true,
  isActive: false,
};

export default PaginateKey;
